module.exports = __webpack_public_path__ + "static/media/Call-white.6b1e4342.svg";